export const pricing = {
	title: "PRECIOS",
	fields: {
		saleType: {
			label: "Tipo de venta",
			placeholder: "Unidad",
			options: {
				unit: "Unidad",
				gram: "Gramos",
				liter: "Mililitros",
				variable: "Precio Variable",
			},
		},
		unitOfMeasure: {
			label: "Unidad de medida",
			placeholder: "Gramo",
			fixedUnit: "Unidad (1)",
			options: {
				gramas: "Gramos",
				ml: "Mililitros",
			},
		},
		quantity: {
			label: "Cantidad",
			placeholder: "100",
		},
		price: {
			label: "Precio",
			placeholder: "00,00",
			tooltip: "Precio opcional, puedes definirlo o cambiarlo en el POS",
		},
		releasePrice: {
			label: "Tiene precio de suelta?",
			tooltip: "Valor de traspaso del producto para que el ambulante venda en el evento.",
			yes: "sí",
			no: "no",
			priceLabel: "Precio de suelta",
			placeholder: "00,00",
		},
		isReturnableProduct: {
			label: "Producto retornable",
			tooltip:
				"Producto que puede ser devuelto por el cliente después de la compra, dentro del plazo y condiciones establecidos.",
			yes: "sí",
			no: "no",
		},
	},
	variablePriceInfo: {
		title: "Precio definido en el POS",
		description:
			"Los productos con precio variable no tienen un valor fijo. El precio se informa en el POS en el momento de la venta.",
	},
};
